import styled from 'vue3-styled-components';

export const HeaderDiv = styled.header`
    position: relative;
    height: 50px;
    margin-bottom: 20px;
    
    .header {
        position: fixed;
        display: flex;
        justify-content: space-between;
        top: 0;
        left: 0;
        width: 100%;
        height: 50px;
        background-color: #fff;
        border-bottom: 2px solid #fb8b24;
        z-index: 9999;
    }

    .menu-container {
        position: relative;
        display: flex;
        padding: 0 30px;
    }

    .menu {
        position: relative;
        display: flex;
        width: 130px;
        flex-direction: column;
    }

    .main-menu {
        display: flex;
        height: 50px;
        font-size: 20px;
        align-items: center;
        justify-content: center;
        position: relative;

        &:hover {
            transform: translateY(-3px);
        }
    
        &:active {
            transform: translateY(-1px);
        }

        &.active {
            color: #fb8b24;
            font-weight: bold;

        &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 3px;
            background-color: #fb8b24;
            transition: all 0.3s;
            }
        }

        a {
            text-decoration: none;
            color: inherit;
        }
    }

    .sub-menu {
        position: absolute;
        top: 50px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 9999;

        a {
            height: 50px;
            width: 100%;
            font-size: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            &:hover {
                color: #fb8b24;
            }
        }
    }

    .sub-menu2 {
        position: absolute;
        top: 85px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 9999;

        a {
            height: 50px;
            width: 100%;
            font-size: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            &:hover {
                color: #fb8b24;
            }
        }
    }

    .account {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 50px;
        gap: 10px;
        .logout {
            cursor: pointer;

            &:hover {
                transform: translateY(-3px);
            }
    
            &:active {
                transform: translateY(-1px);
            }
        }
    }
`;

export const HeaderDropdownBackgroundDiv = styled.div`
    position: fixed;
    top: 50px;
    left: 0;
    width: 100%;
    height: calc(100% - 50px);
    z-index: 9998;
    
    .menu-section {
        height: 100px; /* 픽셀 단위로 직접 지정 */
        background-color: #fff;
    }

    .background-section{
        height: calc(100% - 100px); /* 남은 공간 채우기 */
        background-color: rgba(0, 0, 0, 0.5);
    }
`;

// 유저 섹션 스타일드 컴포넌트들
export const UserSection = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    padding: 8px 12px;
    border-radius: 8px;
    transition: all 0.2s ease;
    position: relative;
    z-index: 1001;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }
`;

export const UserIconContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const MessageBadge = styled.div`
    position: absolute;
    right: -4px;
    background: #6b7280;
    color: white;
    border-radius: 50%;
    min-width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    border: 2px solid white;
    transition: all 0.2s ease;
    
    // 메시지가 있을 때 빨간색으로 변경
    &.has-messages {
        background: #ef4444;
        animation: pulse 2s infinite;
    }
    
    @keyframes pulse {
        0% { transform: scale(1); }
        50% { transform: scale(1.1); }
        100% { transform: scale(1); }
    }
`;

export const MessageDropdown = styled.div`
    position: absolute;
    top: 100%;
    right: 2%;
    width: 350px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    border: 1px solid #e2e8f0;
    z-index: 1002;
    margin-top: 8px;
    overflow: hidden;
`;

export const MessageHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    
    h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        color: #374151;
    }
`;

export const MarkAllReadButton = styled.button`
    background: #0f4c5c;
    color: white;
    border: none;
    border-radius: 6px;
    padding: 4px 8px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        background: #0f4c5c;
    }
`;

export const MessageList = styled.div`
    max-height: 400px;
    overflow-y: auto;
    
    &::-webkit-scrollbar {
        width: 4px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f5f9;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #cbd5e1;
        border-radius: 2px;
    }
`;

export const NoMessages = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    color: #9ca3af;
    
    i {
        font-size: 32px;
        margin-bottom: 12px;
    }
    
    p {
        margin: 0;
        font-size: 14px;
    }
`;

export const MessageItem = styled.div`
    display: flex;
    align-items: flex-start;
    padding: 12px 20px;
    border-bottom: 1px solid #f1f5f9;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    
    &:hover {
        background: #f8fafc;
    }
    
    &.unread {
        background: #f0f9ff;
        border-left: 3px solid #0f4c5c;
    }
`;

export const MessageContent = styled.div`
    flex: 1;
    min-width: 0;
`;

export const MessageTitle = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const MessageText = styled.div`
    font-size: 13px;
    color: #6b7280;
    line-height: 1.4;
    margin-bottom: 4px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

export const MessageTime = styled.div`
    font-size: 11px;
    color: #9ca3af;
`;

export const MessageActions = styled.div`
    display: flex;
    align-items: center;
    margin-left: 8px;
`;

export const DeleteMessageButton = styled.button`
    width: 24px;
    height: 24px;
    border: none;
    background: transparent;
    color: #9ca3af;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    
    &:hover {
        background: #f3f4f6;
        color: #ef4444;
    }
    
    i {
        font-size: 12px;
    }
`;

export const MessageFooter = styled.div`
    padding: 12px 20px;
    background: #f8fafc;
    border-top: 1px solid #e2e8f0;
`;

export const ClearAllButton = styled.button`
    width: 100%;
    background: #ef4444;
    color: white;
    border: none;
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        background: #dc2626;
    }
`;

export const UserId = styled.span`
    font-size: 17px;
    font-weight: 500;
    color: #374151;
    cursor: pointer;
    position: relative;

    &:hover {
        transform: translateY(-3px);
    }

    &:active {
        transform: translateY(-1px);
    }
`;